//? Langues de l'application et locale BCP 47 correspondante (Intl, date-fns, attribut lang).
//? zh-CHT, code .NET partagé avec l'API, n'est pas un code BCP 47 : Intl lèverait une RangeError
export const LOCALES = { 'fr-BE': 'fr-BE', 'nl-BE': 'nl-BE', 'en-US': 'en-US', 'es-ES': 'es-ES', 'zh-CHT': 'zh-TW' };
